import { render, staticRenderFns } from "./CadastroMotivoGlosa.vue?vue&type=template&id=f70a8b20&"
import script from "./CadastroMotivoGlosa.vue?vue&type=script&lang=js&"
export * from "./CadastroMotivoGlosa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports